interface SectionHeaderProps {
  title: string;
  subtitle?: string;
}

const SectionHeader = ({ title, subtitle }: SectionHeaderProps) => {
  return (
    <div>
      <div className="sectionTitle">{title}</div>
      {subtitle ? <div className="sectionSub">{subtitle}</div> : null}
    </div>
  );
};

export default SectionHeader;
